import { useCallback, useEffect } from 'react';
import { View, Text, Image, Pressable, StyleSheet } from 'react-native';
import { useAppStore } from '../store/appStore';
import { useAppNavigate } from '../hooks/useRouteParams';
import { useTheme } from '../styles/theme';

export default function HomePage() {
  const settings = useAppStore((s) => s.settings);
  const chapters = useAppStore((s) => s.chapters);
  const setAppTitle = useAppStore((s) => s.setAppTitle);
  const navigate = useAppNavigate();
  const { colors } = useTheme();

  useEffect(() => { setAppTitle(''); }, [setAppTitle]);

  const lastCh = settings.last_ch;
  const lastVs = settings.last_vs;
  const lastChName =
    lastCh && chapters.length > 0
      ? chapters.find((c) => c.chapter_number === Number(lastCh))
          ?.chapter_name_ar_english ?? ''
      : '';
  const scrollPos = settings.scroll_position;

  const continueReading = useCallback(() => {
    if (lastCh) {
      const path = lastVs ? `/${lastCh}/${lastVs}` : `/${lastCh}`;
      const search = scrollPos ? `?p=${scrollPos}` : '';
      navigate(path + search);
    }
  }, [lastCh, lastVs, scrollPos, navigate]);

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Image
          source={{ uri: '/others/icon-256.png' }}
          style={styles.icon}
          resizeMode="contain"
        />
      </View>
      {lastCh !== '' && (
        <View style={styles.continueContainer}>
          <Text style={[styles.continueText, { color: colors.primaryText }]}>
            You were reading Surah {lastChName}.
          </Text>
          <Pressable style={[styles.continueBtn, { backgroundColor: colors.topBarBg }]} onPress={continueReading}>
            <Text style={styles.continueBtnText}>Continue Reading</Text>
          </Pressable>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  iconContainer: {
    marginTop: '20%' as any,
    marginBottom: '10%' as any,
    alignItems: 'center',
  },
  icon: {
    width: 150,
    height: 150,
  },
  continueContainer: {
    alignItems: 'center',
  },
  continueText: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 16,
  },
  continueBtn: {
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 2,
    marginBottom: '10%' as any,
    // @ts-expect-error web shadow
    boxShadow: '2px 2px 4px 0 rgba(0,0,0,.26)',
  },
  continueBtnText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '600',
    // @ts-expect-error web text-transform
    textTransform: 'uppercase',
  },
});
